import {createAction} from '@reduxjs/toolkit';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

const ADD_TRIGGER_ATTACHMENT = 'ADD_TRIGGER_ATTACHMENT';
const CLEAR_TRIGGER_ATTACHMENT = 'CLEAR_TRIGGER_ATTACHMENT';
const SET_TRIGGER_ATTACHMENTS = 'SET_TRIGGER_ATTACHMENTS';
const REMOVE_TRIGGER_ATTACHMENT = 'REMOVE_TRIGGER_ATTACHMENT';
const DEACTIVATE_TRIGGER_ATTACHMENT = 'DEACTIVATE_TRIGGER_ATTACHMENT';
const ACTIVATE_TRIGGER_ATTACHMENT = 'ACTIVATE_TRIGGER_ATTACHMENT';

export const addTriggerAttachment = createAction<TriggerAttachment>(ADD_TRIGGER_ATTACHMENT);
export const clearTriggerAttachments = createAction(CLEAR_TRIGGER_ATTACHMENT);
export const setTriggerAttachments = createAction<TriggerAttachment[]>(SET_TRIGGER_ATTACHMENTS);
export const removeTriggerAttachment = createAction<string>(REMOVE_TRIGGER_ATTACHMENT);
export const deactivateTriggerAttachment = createAction<number>(DEACTIVATE_TRIGGER_ATTACHMENT);
export const activateTriggerAttachment = createAction<number>(ACTIVATE_TRIGGER_ATTACHMENT);

